import { connect } from 'react-redux';
import { hideMobileMenu } from '../../state/actions/mobileMenuActions';

import MobileMenu from './MobileMenu';

export default connect(
    state => ({ isMobileMenuVisible: state.mobileMenu.isMobileMenuVisible}),
    { hideMobileMenu }
)(MobileMenu);